// External Dependencies:
import { browserHistory } from 'react-router'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

export function requestPage( type, slug, requestOnly ) {
	return {
		type: 'REQUEST_PAGE_DATA',
		payload: {
			type: type,
			slug: slug,
			requestOnly: requestOnly
		}
	}
}

export function receivePage( type, slug, categorySlug, json ) {
	return {
		type: 'RECEIVE_PAGE_DATA',
		payload: {
			type: type,
			slug: slug,
			categorySlug: categorySlug,
			data: json
		}
	}
}

export function receivePageError( json ) {
	return {
		type: 'RECEIVE_PAGE_ERROR',
		payload: json
	}
}

export function setCurrentPage( slug ) {
	return {
		type: 'SET_CURRENT_PAGE',
		payload: slug
	}
}

export function appendPage( slug ) {
	return {
		type: 'APPEND_PAGE',
		payload: slug
	}
}

export function setCurrentlyViewedPage( slug ) {
	// Update url:
	window.history.pushState( null, null, `/article/${slug}` )

	return {
		type: 'SET_CURRENTLY_VIEWED_PAGE',
		payload: slug
	}
}

export function registerPageView( id ) {
	return function( dispatch, getState ) {
		const { pageViewsRegisteredIds } = getState().page

		if ( pageViewsRegisteredIds.includes( id ) ) {
			return
		}

		const url = `${siteData.api_base_url}post-view/?id=${id}`

		return doRequest( url, {
			credentials: 'include'
		})
			.then( json => {
				dispatch( updatePageViewsRegistered( id ) )
			})
			.catch( error => {
				console.log( error, 'error' )
			})
	}
}

export function updatePageViewsRegistered( id ) {
	return {
		type: 'UPDATE_PAGE_VIEWS_REGISTERED',
		payload: id
	}
}

export function getPageData( {
	type = 'page',
	slug = '',
	categorySlug = '',
	year = '',
	month = '',
	archivePageNumber = false,
	skip = 0,
	number = 1,
	requestOnly = false,
	force = false,
	append = false,
	skipLatest = false
} = {} ) {
	return function( dispatch, getState ) {
		const { byId, postsById, loadingById } = getState().page
		const { wpRestNonce } = getState().site
		const theById = ( 'posts' == type ) ? postsById : byId

		if ( ! slug && categorySlug ) {
			slug = categorySlug
		}

		// Normalise slug, removing /
		slug = slug ? slug.replace( /\//g, '' ) : false
		categorySlug = categorySlug ? categorySlug.replace( /\//g, '' ) : false

		// Don't load the same thing simultaneously:
		if ( loadingById[ 'id_' + slug ] ) {
			return
		}

		// Short circuit for existing data:
		if ( ! force && theById[ 'id_' + slug ] ) {
			if ( ! requestOnly ) {
				dispatch( receivePage( slug, theById[ 'id_' + slug ] ) )
			}

			if ( ! append && ! requestOnly ) {
				dispatch( setCurrentPage( slug ) )
			}

			return
		}

		dispatch( requestPage( type, 'id_' + slug, requestOnly ) )

		if ( ! requestOnly ) {
			dispatch( showLoading() )
		}

		const url = `${siteData.api_base_url}${type}/?slug=${slug}&category_slug=${categorySlug}&year=${year}&month=${month}&page_number=${archivePageNumber}&skip=${skip}&number=${number}&skip_latest=${skipLatest}`

		return doRequest( url, {
			credentials: 'include',
			headers: {
				'X-WP-Nonce': wpRestNonce
			}
		})
			.then( json => {
				dispatch( receivePage( type, slug, categorySlug, json ) )

				if ( ! requestOnly ) {
					dispatch( hideLoading() )
				}

				if ( ! append && ! requestOnly ) {
					dispatch( setCurrentPage( slug ) )
				}

				if ( append ) {
					dispatch( appendPage( slug ) )
				}
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}
